<template>
  <div class="web">
    <div class="Empty">
      <div class="EmptyImage">
        <img src="../../../assets/images/frozen.png" alt="" />
      </div>
      <p class="text">您的账户已被冻结...</p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.EmptyImage{
    width: 227px;
    height: 240px;
}
.text {
  margin-top: 50px;
  font-size: 21px;
}
</style>
